import { transferCodeBlockWrappedValue } from '@atlaskit/editor-common/code-block';
import type { BreakoutMode } from '@atlaskit/editor-common/types/breakout';
import type { Command } from '@atlaskit/editor-common/types/command';
import { NodeSelection } from '@atlaskit/editor-prosemirror/state';
import type { Transaction } from '@atlaskit/editor-prosemirror/state';
import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';

import { updateExpandedStateNew } from '../pm-plugins/utils/single-player-expand';

export function setBreakoutWidth(
	width: number,
	mode: BreakoutMode,
	pos: number,
	isLivePage?: boolean,
): Command {
	return (state, dispatch) => {
		const node = state.doc.nodeAt(pos);
		if (!node) {
			return false;
		}

		let tr: Transaction;
		if (isExperimentEnabled('platform_editor_lovability_resize_extensions')) {
			const marks = state.schema.marks.breakout.create({ width, mode }).addToSet(node.marks);
			tr = state.tr.setNodeMarkup(pos, node.type, node.attrs, marks);
		} else {
			tr = state.tr.setNodeMarkup(pos, node.type, node.attrs, [
				state.schema.marks.breakout.create({ width, mode }),
			]);
		}

		if (node.type === state.schema.nodes.expand) {
			updateExpandedStateNew({ tr, node, pos, isLivePage });
		} else if (node.type === state.schema.nodes.codeBlock) {
			const newNode = tr.doc.nodeAt(pos);
			const oldNode = node;
			if (newNode) {
				transferCodeBlockWrappedValue(oldNode, newNode);
			}
		}

		tr.setMeta('scrollIntoView', false);

		// keep current selection, necessary to not remove NodeSelection for keyboard resizing
		if (state.selection instanceof NodeSelection && state.selection.node.eq(node)) {
			tr.setSelection(NodeSelection.create(tr.doc, pos));
		}

		if (dispatch) {
			dispatch(tr);
		}

		return true;
	};
}
